import React, { FC, useEffect } from 'react';

import { ComposeNodeType } from '../../../../containers/compose/props';
import useAttachmentsUpload from '../../../../hooks/attachments/useAttachmentUpload';
import postPermissionCameraEvent from '../../../../native-messaging/handlers/web/permissionCamera';
import AttachmentUploadSection from '../../../MUI/AttachmentUploadSection';

type Props = {
  nodeType: ComposeNodeType;
};

/**
 * Attachment upload section for the compose footer
 *
 * @param props          Props passed to the component
 * @param props.nodeType Whether the compose form is being used for messages or templates
 *
 * @returns              The component itself
 */
const ComposeFooterAttachment: FC<Props> = ({ nodeType }) => {
  const { attachmentsFormatted, inputProps } = useAttachmentsUpload(nodeType);

  /** Check for camera permission on native app */
  useEffect(() => {
    postPermissionCameraEvent();
  }, []);

  return (
    <AttachmentUploadSection
      attachmentsListLength={attachmentsFormatted.length}
      inputFileProps={inputProps}
    />
  );
};

export default ComposeFooterAttachment;
